import { isNil } from 'lodash';
import { useEffect } from 'react';

import { getShopConfiguration } from 'utils/storeUtils';

interface MetaTagsProps {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  twitterTitle?: string;
  twitterDescription?: string;
}

export const useMetaTags = ({
  title,
  description,
  ogTitle,
  ogDescription,
  twitterTitle,
  twitterDescription,
}: MetaTagsProps) => {
  useEffect(() => {
    const { embed, setDocTitle } = getShopConfiguration();
    if (isNil(setDocTitle) ? !embed : setDocTitle) {
      // Set title
      if (title) {
        document.title = title;
      }

      // Set meta description
      if (description) {
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
          metaDescription = document.createElement('meta');
          metaDescription.setAttribute('name', 'description');
          document.head.appendChild(metaDescription);
        }
        metaDescription.setAttribute('content', description);
      }

      // Set Open Graph title
      if (ogTitle) {
        let ogTitleMeta = document.querySelector('meta[property="og:title"]');
        if (!ogTitleMeta) {
          ogTitleMeta = document.createElement('meta');
          ogTitleMeta.setAttribute('property', 'og:title');
          document.head.appendChild(ogTitleMeta);
        }
        ogTitleMeta.setAttribute('content', ogTitle);
      }

      // Set Open Graph description
      if (ogDescription) {
        let ogDescMeta = document.querySelector('meta[property="og:description"]');
        if (!ogDescMeta) {
          ogDescMeta = document.createElement('meta');
          ogDescMeta.setAttribute('property', 'og:description');
          document.head.appendChild(ogDescMeta);
        }
        ogDescMeta.setAttribute('content', ogDescription);
      }

      // Set Twitter title
      if (twitterTitle) {
        let twitterTitleMeta = document.querySelector('meta[name="twitter:title"]');
        if (!twitterTitleMeta) {
          twitterTitleMeta = document.createElement('meta');
          twitterTitleMeta.setAttribute('name', 'twitter:title');
          document.head.appendChild(twitterTitleMeta);
        }
        twitterTitleMeta.setAttribute('content', twitterTitle);
      }

      // Set Twitter description
      if (twitterDescription) {
        let twitterDescMeta = document.querySelector('meta[name="twitter:description"]');
        if (!twitterDescMeta) {
          twitterDescMeta = document.createElement('meta');
          twitterDescMeta.setAttribute('name', 'twitter:description');
          document.head.appendChild(twitterDescMeta);
        }
        twitterDescMeta.setAttribute('content', twitterDescription);
      }
    }
  }, [title, description, ogTitle, ogDescription, twitterTitle, twitterDescription]);
};
